// src/components/CopyLinkIcon.jsx

import React from 'react';
import { SvgIcon } from '@mui/material';

const CopyLinkIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 11">
      <path d="M9.5 10.5H5.5C4.11667 10.5 2.93767 10.0123 1.963 9.037C0.988334 8.06167 0.500667 6.88267 0.500001 5.5C0.499334 4.11733 0.987001 2.93833 1.963 1.963C2.939 0.987667 4.118 0.5 5.5 0.5H9.5V2.5H5.5C4.66667 2.5 3.95833 2.79167 3.375 3.375C2.79167 3.95833 2.5 4.66667 2.5 5.5C2.5 6.33333 2.79167 7.04167 3.375 7.625C3.95833 8.20833 4.66667 8.5 5.5 8.5H9.5V10.5ZM6.5 6.5V4.5H14.5V6.5H6.5ZM11.5 10.5V8.5H15.5C16.3333 8.5 17.0417 8.20833 17.625 7.625C18.2083 7.04167 18.5 6.33333 18.5 5.5C18.5 4.66667 18.2083 3.95833 17.625 3.375C17.0417 2.79167 16.3333 2.5 15.5 2.5H11.5V0.5H15.5C16.8833 0.5 18.0627 0.987667 19.038 1.963C20.0133 2.93833 20.5007 4.11733 20.5 5.5C20.4993 6.88267 20.0117 8.062 19.037 9.038C18.0623 10.014 16.8833 10.5013 15.5 10.5H11.5Z" fill="currentColor"/>
    </SvgIcon>
  );
};

export default CopyLinkIcon;